import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight, Phone } from "lucide-react";
import { NAV, LOGO_WHITE } from "../data/projects";

export const Footer = () => (
  <footer className="bg-[#2F3438] text-white pt-24 pb-10" data-testid="footer">
    <div className="mx-auto max-w-[1440px] px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
        <div className="lg:col-span-5">
          <div className="mb-6">
            <img src={LOGO_WHITE} alt="DEKO Kozijnen logo" className="h-14 w-auto" data-testid="footer-logo" />
          </div>
          <p className="font-display text-2xl sm:text-3xl font-semibold leading-tight max-w-md">
            Kwaliteit waar je op kunt bouwen.
          </p>
        </div>
        <div className="lg:col-span-3 lg:col-start-7">
          <div className="text-xs uppercase tracking-widest text-white/40 mb-5">Navigatie</div>
          <div className="space-y-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="block text-white/70 hover:text-white transition-colors">{n.label}</Link>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-widest text-white/40 mb-5">Contact</div>
          <a href="tel:+31640627499" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-3" data-testid="footer-phone">
            <Phone className="h-4 w-4" /> 06 40 62 74 99
          </a>
          <a href="mailto:Noakoelhuis@live.nl" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-3">
            <Mail className="h-4 w-4" /> Noakoelhuis@live.nl
          </a>
          <div className="flex items-center gap-2 text-white/70 mb-6"><MapPin className="h-4 w-4" /> Noord-Nederland</div>
          <Link to="/offerte" className="inline-flex items-center gap-2 bg-white text-[#2F3438] px-5 py-3 rounded-sm hover:bg-white/90 transition-colors text-sm font-medium">
            Offerte aanvragen <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
        <span>© {new Date().getFullYear()} DEKO Kozijnen. Alle rechten voorbehouden.</span>
        <span>Kunststof kozijnen, deuren & schuifpuien — Noord-Nederland</span>
      </div>
    </div>
  </footer>
);
